// istanbul ignore file

import { createContext } from 'react';
import { PromiseState } from '@cld/use-promise-state';

import { AssetShareData } from '../../services/dataService/AssetShareData';

export const DataContext = createContext<PromiseState<AssetShareData> | undefined>(undefined);
